import React from "react";
import { Card } from "../modules/Crops/CropsManagement";

export function CropCardPage(props) {
  return <Card {...props} />;
}
